<template lang="pug">
.auth-services
  div
    EsiaLink.auth-services_btn(v-if='isEsiaModule')
  | {{ errMsg }}
</template>

<script>
import IsEsiaCheckMixin from '@/mixins/isEsiaCheck';
import EsiaLink from '@/components/esialink';
import esiaStore from '../esia-store.js';
import isArrayNotEmpty from '@/tools/isarraynotempty';
export default {
  name: 'AuthServices',
  mixins: [IsEsiaCheckMixin],
  components: {
    EsiaLink,
  },
  computed: {
    isEsiaError() {
      return isArrayNotEmpty(esiaStore.esiaError);
    },

    errMsg() {
      return this.isEsiaError ? esiaStore.esiaError : null;
    },
  },
};
</script>

<style scoped lang="stylus">
.auth-services{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding 30px
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 700;
  border: 1px dashed #ced0dc;

  &_btn{
    font-weight: 600;
    font-size: 14px;
    font-family: 'Open Sans';
    display: -ms-flexbox;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid #a9a9a9 !important;
    border-radius: 12px;
    cursor: pointer;
    display: flex !important;
    padding: 20px;
    margin: 0 !important;

    &:hover{
      background-color #fff
    }
}
}
</style>



// WEBPACK FOOTER //
// AuthServices.vue?389c803c